module.exports = __webpack_public_path__ + "img/balance-money-header-image.232b71ac.svg";